<script>
	import { createEventDispatcher, onMount } from "svelte";
	import { onDestroy } from "svelte";
	import { slide } from "svelte/transition";

	const dispatch = createEventDispatcher();

	// export let qr_state = "inactive"; //inactive|permissions|active
	export let lang = "bg";

	onMount(() => {
		navigator.mediaDevices
			.getUserMedia({ video: true, audio: false })
			.then((mediaStream) => {
				const stream = mediaStream;
				const tracks = stream.getTracks();

				// tracks[0].stop;
				tracks.forEach((track) => track.stop());
			});

		function domReady(fn) {
			if (
				document.readyState === "complete" ||
				document.readyState === "interactive"
			) {
				setTimeout(fn, 1000);
			} else {
				document.addEventListener("DOMContentLoaded", fn);
			}
		}

		domReady(function () {
			// If found you qr code
			function onScanSuccess(decodeText, decodeResult) {
				dispatch("qr_read", decodeText);

				// console.warn(decodeText, decodeResult);
				// alert("You Qr is : " + decodeText, decodeResult);
				let shouldPauseVideo = true;
				let showPausedBanner = false;
				htmlscanner.pause(shouldPauseVideo, showPausedBanner);
				// htmlscanner.clear();
			}

			// const formatsToSupport = [
			// 	Html5QrcodeSupportedFormats.QR_CODE,
			// 	Html5QrcodeSupportedFormats.UPC_A,
			// 	Html5QrcodeSupportedFormats.UPC_E,
			// 	Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
			// ];

			let htmlscanner = new Html5QrcodeScanner("qr-reader", {
				fps: 10,
				qrbos: 250,
				rememberLastUsedCamera: true,
				formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
				supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
			}); //config here ^
			htmlscanner.render(onScanSuccess);
		});

		// function destroyScanner() {
		// 	htmlscanner.clear();
		// }
	});

	onDestroy(() => {
		// stream.getTracks().forEach(function (track) {
		// 	track.stop();
		// });

		// function stopBothVideoAndAudio(stream) {
		// 	stream.getTracks().forEach((track) => {
		// 		if (track.readyState == "live") {
		// 			track.stop();
		// 		}
		// 	});
		// }
		// stopBothVideoAndAudio();

		// https://dev.to/morinoko/stopping-a-webcam-with-javascript-4297
		const video = document.querySelector("video");

		if (video != undefined) {
			// A video's MediaStream object is available through its srcObject attribute
			const mediaStream = video.srcObject;
			// Through the MediaStream, you can get the MediaStreamTracks with getTracks():
			const tracks = mediaStream.getTracks();
			tracks.forEach((track) => track.stop());
		} else {
			navigator.mediaDevices
				.getUserMedia({ video: true, audio: false })
				.then((mediaStream) => {
					const stream = mediaStream;
					const tracks = stream.getTracks();

					// tracks[0].stop;
					tracks.forEach((track) => track.stop());
				});
		}
		// console.warn(75);
	});
</script>

<svelte:head>
	<script defer src={"/js/html5-qrcode-" + lang + ".min.js"}></script>
	<!-- <link rel="stylesheet" href="/css/html5-qrcode.css" /> -->
</svelte:head>

<div
	transition:slide
	class="box-border fixed z-10 grid place-center !text-inherit w-full h-full p-5 left-0 overflow-auto bg-blue-200 obelisk"
	style="top:0px"
	id="qr-scanner"
>
	<button
		class="ghost icon m-3 absolute z-20"
		on:click={() => dispatch("state", false)}
	>
		<i
			class="fa-solid fa-arrow-left fa-fw"
			aria-hidden="true"
			data-position="center"
		/>
		<!-- v0.28 -->
	</button>

	<div id="qr-reader">
		<img alt="Info" class=" hidden" />
	</div>

	<!-- <button
		on:click={() => {
			// qr_state = false;
			dispatch("state", false);
		}}>Close QR</button
	> -->
</div>

<style>
	:global(#qr-scanner #qr-reader) {
		/* padding: 20px !important;
		border: 1.5px solid #b2b2b2 !important;
		border-radius: 8px; */
		position: relative;
		/* padding: 20px;
		border: 2px solid red; */
		display: grid;
		align-content: center;
	}
	:global(#qr-scanner #qr-reader video) {
		border-radius: 20px;
		border: 2px solid white;
		box-sizing: border-box;
		max-width: min(90vh, 90vw);
		margin: auto;
		width: auto !important;
	}

	:global(#qr-scanner #qr-reader img[alt="CameraBasedScan"]) {
		width: 100px !important;
		height: 100px !important;
		margin: auto;
	}

	:global(#qr-scanner #qr-credits) {
		/* @apply absolute border-none bg-black bg-opacity-30 top-3 right-3 z-10 text-sm; */
		position: absolute;
		padding: 8px 13px 10px;
		border: none;
		background: rgba(0, 0, 0, 0.3);
		border-radius: 0;
		text-align: left;
		top: 10px;
		right: 10px;
		z-index: 2;
		font-size: 10pt;
		color: inherit;
		display: none;
	}

	:global(#qr-scanner select) {
		max-width: 80vw;
	}

	/* button {
		padding: 10px 20px;
		border: 1px solid #b2b2b2;
		outline: none;
		border-radius: 0.25em;
		color: white;
		font-size: 15px;
		cursor: pointer;
		margin-top: 15px;
		margin-bottom: 10px;
		background-color: #008000ad;
		transition: 0.3s background-color;
	} */

	/* button:hover {
		background-color: #008000;
	} */

	/* #html5-qrcode-anchor-scan-type-change {
		text-decoration: none !important;
		color: #1d9bf0;
	} */

	/* video {
		width: 100% !important;
		border: 5px solid #b2b2b2 !important;
		border-radius: 1em;
	} */
</style>
